<template>
  <section
    id="yhteystiedot"
    class="section"
  >
    <h2 class="section__heading section__heading--alt2">
      Asiakkaan yhteystiedot
    </h2>

    <div class="checkout__rows">
      <div class="checkout__header">
        <div class="cart__search">
          <label
            class="cart__search__label"
            for="client-search"
          >
            <h3 class="checkout__header__heading">Asiakas</h3>
          </label>
          <CheckoutClientSearch
            v-if="$store.getters.changesAllowed"
            :nonce="nonce"
            @change="customerChanged($event)"
          />
        </div>
      </div>
      <div
        v-if="customer.billing && customer.billing.company_id"
        class="checkout__subsection"
      >
        <div
          v-if="customer.warn_text"
          class="error-notification"
        >
          <p>Varoitus: {{ customer.warn_text }}</p>
        </div>
        <div class="checkout__offer-client">
          <p>
            <strong v-if="customer.billing.company">{{ customer.billing.company }}<br></strong>
            <template v-if="customer.billing.company_id">
              Y-tunnus: {{ customer.billing.company_id }}<br>
            </template>
            <template v-if="customer.billing.customer_code">
              Asiakasnumero: {{ customer.billing.customer_code }}<br>
            </template>
            <template v-if="customer.paydeal">
              Maksuehto: {{ customer.paydeal }} päivää<br>
            </template>
          </p>
        </div>
        <div class="field">
          <label for="customer_company">Yrityksen nimi</label>
          <input
            id="customer_company"
            v-model="customer.billing.company"
            type="text"
            :disabled="!$store.getters.changesAllowed"
            @change="localCustomerStateChanged"
          >
        </div>
        <div class="field field--float">
          <label for="customer_first_name">Etunimi</label>
          <input
            id="customer_first_name"
            v-model="customer.billing.first_name"
            type="text"
            :disabled="!$store.getters.changesAllowed"
            @change="localCustomerStateChanged"
          >
        </div>
        <div class="field">
          <label for="customer_last_name">Sukunimi</label>
          <input
            id="customer_last_name"
            v-model="customer.billing.last_name"
            type="text"
            :disabled="!$store.getters.changesAllowed"
            @change="localCustomerStateChanged"
          >
        </div>
        <div class="field field--float">
          <label for="customer_email">Sähköposti</label>
          <input
            id="customer_email"
            v-model="customer.billing.email"
            type="email"
            :disabled="!$store.getters.changesAllowed"
            @change="localCustomerStateChanged"
          >
        </div>
        <div class="field">
          <label for="customer_phone">Puhelin</label>
          <input
            id="customer_phone"
            v-model="customer.billing.phone"
            type="tel"
            :disabled="!$store.getters.changesAllowed"
            @change="localCustomerStateChanged"
          >
        </div>
      </div>
      <div
        v-else
        class="checkout__subsection"
      >
        <div class="checkout__subsection__empty">
          Ei valittua asiakasta
        </div>
      </div>
    </div>
  </section>
</template>

<script>
    import axios from 'axios';
    import CheckoutClientSearch from './checkout-client-search.vue';
    import { EventBus } from '../../event-bus';

    export default {

        components: {
            CheckoutClientSearch,
        },
        props: {
            originalCustomer: {
                type: Object,
                default: function(){
                    return {};
                },
            },
            nonce: {
                type: String,
                default: '',
            },
        },
        data : function () {
            return {
                customer: false,
            }
        },

        mounted: function() {
            this.updateCustomerState(this.originalCustomer);
        },

        methods: {
            localCustomerStateChanged() {
                this.customerChanged(this.customer);
            },

            customerChanged(customer) {
                this.updateCustomerState(customer);
                this.updateCustomerToOffer(customer);
            },

            updateCustomerToOffer(customer) {
                let request = {
                    'customer': customer,
                }

                let config = {
                    headers: {
                        'X-WP-Nonce': this.nonce,
                    },
                }

                axios.post('/wp-json/modeo/v2/cart/save_offer_customer', request, config).catch( ( error ) => {
                    if ( error.response ) {

                        if ( error.response.status === 403 && error.response.data.code === 'Forbidden' ) {
                            let productAddedToCartData = {
                                message: this.$modeoL10n.offer_modification_failed,
                                notificationType: 'single-message',
                            };
                            EventBus.$emit( 'notify', productAddedToCartData );
                        }

                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log( error.response.data );
                        console.log( error.response.status );
                        console.log( error.response.headers );
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log( 'Error', error.message );
                    }
                    console.log( error.config );
                } );
            },

            updateCustomerState(customer) {
                this.customer = customer;
                this.$store.commit('setCustomer', customer);
            },

        },
    }
</script>
